import "../css/index.css";

import colorScheme from "./color-scheme.js";
import mobileMenu from "./mobile-menu.js";
import imageCarousel from "./image-carousel.js";
import masonry from "./masonry.js";
import imagesLoaded from "imagesloaded";

document.addEventListener('DOMContentLoaded', () => {
    colorScheme.init();
    mobileMenu.init();
    imageCarousel.init();
    const m = masonry.init();

    const imageContainer = document.querySelector('.masonry');
    imagesLoaded(imageContainer).on('progress', () => {
        m.layout();
    });
});
